<template>
    <header class="header">
        <div class="inner">
            <div class="accessibility" @click="toggleDarkMode"><span class="ico"></span>{{ isDarkMode ? 'Default Mode' :
                'Accessibility Mode' }}</div>
            <h1 class="logo">
                <router-link to="/">
                    {{ $store.state.site_name }}
                </router-link>
            </h1>
            <ul class="top-navi">
                <li><router-link to="/support-us"><span class="num">8</span>Support us</router-link></li>
                <li @click="toggleMenu"><span class="num">0</span>for Menu</li>
            </ul>
            <i class="mobile-trigger" @click="toggleMenu">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <line x1="3" y1="12" x2="21" y2="12"></line>
                    <line x1="3" y1="6" x2="21" y2="6"></line>
                    <line x1="3" y1="18" x2="21" y2="18"></line>
                </svg>
            </i>
        </div>
    </header>
</template>

<script>
import Link from '@/components/ui/Link.vue';
import Hover from '@/components/ui/Hover.vue';


export default {
    name: 'Header',

    components: {
        Link,

        Hover,
    },

    data() {
        return {
            isDarkMode: false,
        };
    },

    created() {
        // Early initialization to prevent flashing
        const savedDarkMode = localStorage.getItem('darkMode');
        if (savedDarkMode === 'true') {
            this.isDarkMode = true;
        }
    },

    mounted() {
        // Apply dark mode class if needed
        if (this.isDarkMode) {
            document.documentElement.classList.add('dark-mode');
        }
    },

    methods: {
        toggleMenu() {
            this.EventBus.emit('toggle-navi');
        },

        toggleDarkMode() {
            this.isDarkMode = !this.isDarkMode;
            document.documentElement.classList.toggle('dark-mode', this.isDarkMode);
            localStorage.setItem('darkMode', this.isDarkMode.toString());
        },
    },
}
</script>

<style lang="scss">
.fixed-header .header,
.page-home .header {
    position: fixed;
}

.header {
    position: sticky;
    left: 0;
    top: 0;
    z-index: 19;
    width: 100%;
    font-size: var(--medium-size);
    overflow: hidden;
    height: 6.4rem;
    filter: drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.59));
    background: rgba(255, 255, 255, 0.45);
    backdrop-filter: blur(26px);

    h1 {
        font-weight: normal;
    }

    .inner {
        position: relative;
        display: flex;
        align-items: center;
        height: 100%;
    }

    .accessibility {
        flex: 1;
        cursor: pointer;
        display: flex;
        align-items: center;

        .ico {
            height: 3rem;
            width: 3rem;
            display: block;
            margin-right: var(--padding);
            overflow: hidden;
            border-radius: 50%;
            position: relative;
            transition: all 0.3s ease;

            &::before {
                position: absolute;
                left: 0;
                top: 0;
                height: 100%;
                width: 50%;
                background-color: #403A1B;
                content: '';
                transition: all 0.3s ease;
            }

            &::after {
                position: absolute;
                right: 0;
                top: 0;
                height: 100%;
                width: 50%;
                background-color: #BBD8F2;
                content: '';
                transition: all 0.3s ease;
            }
        }

        /* Dark mode styles for accessibility icon */
        html.dark-mode & .ico {
            &::before {
                background-color: #BBD8F2;
            }

            &::after {
                background-color: #403A1B;
            }
        }
    }

    .logo {
        position: absolute;
        left: 0;
        width: 100%;
        text-align: center;
        pointer-events: none;

        a {
            pointer-events: auto;
            transition: all 0.25s ease;
        }

        a:hover {
            color: var(--theme-2);
        }

        @media screen and (max-width: 768px) {
            a:hover {
                color: black;
            }
        }

    }

    .top-navi {
        display: flex;
        align-items: center;

        li {
            margin-left: var(--padding-x2);
            cursor: pointer;
            display: flex;
            align-items: center;

            &>a {
                display: flex;
                align-items: center;
            }

            .num {
                height: 3rem;
                width: 3rem;
                margin-right: var(--padding-50);
                overflow: hidden;
                border-radius: 50%;
                position: relative;
                background-color: var(--theme-1);
                display: flex;
                align-items: center;
                justify-content: center;
                color: white;
                font-size: var(--base-size);
            }

            &:nth-child(2) .num {
                background-color: var(--theme-2);
            }
        }
    }

    .mobile-trigger {
        transition: transform .2s ease-in-out;
        display: none;
        position: absolute;
        right: var(--padding-x2);
        top: 50%;
        margin-top: -2.2rem;
        height: 4.4rem;
        width: 4.4rem;

        svg {
            fill: none;
            stroke: var(--font-color);
            height: 100%;
            width: 100%;

            line {
                stroke-width: 1.8;
                transition: .2s all ease;
            }
        }
    }


    @media screen and (max-width: 768px) {
        & {
            height: 7.6rem;

            .accessibility {
                color: transparent;
                width: 3.4rem;
                overflow: hidden;

                .ico {
                    height: 3.4rem;
                    width: 3.4rem;
                    margin-right: 0;
                }
            }

            .top-navi {
                display: none;
            }

            .mobile-trigger {
                display: block;
            }
        }

    }


    // .mobile-trigger {
    //     transition: transform .2s ease-in-out;
    //     display: none;
    //     position: absolute;
    //     right: var(--padding);
    //     top: 50%;
    //     margin-top: -2.2rem;
    //     height: 4.4rem;
    //     width: 4.4rem;

    //     svg {
    //         fill: none;
    //         stroke: var(--font-color);
    //         height: 100%;
    //         width: 100%;

    //         line {
    //             stroke-width: 1.8;
    //             transition: .2s all ease;
    //         }
    //     }
    // }



    // .search-form {
    //     position: absolute;
    //     right: 3rem;
    //     z-index: 9;
    //     transition: width .3s ease-in-out;
    //     width: 0;
    //     overflow: hidden;


    //     .input {
    //         width: 52rem;
    //         position: relative;

    //         span {
    //             cursor: pointer;
    //             height: 1.6rem;
    //             width: 1.6rem;
    //             position: absolute;
    //             right: .3rem;
    //             top: 1rem;

    //             svg {
    //                 display: block;
    //                 height: 100%;
    //                 width: 100%;
    //                 stroke: var(--gray);
    //                 stroke-width: 2;
    //             }

    //             &:hover svg {
    //                 stroke: var(--theme-2);
    //             }
    //         }
    //     }

    //     input {
    //         border: none;
    //         border-bottom: 1px solid var(--gray);
    //         width: 100%;
    //         text-transform: lowercase;
    //         font-weight: bold;
    //         font-size: var(--medium-size);
    //         padding: .3rem 0;

    //         &:focus {
    //             outline: none;
    //             border-bottom: 1px solid var(--theme-2);
    //         }
    //     }
    // }

    // .open-search {
    //     .menu-item {
    //         opacity: 0;
    //         pointer-events: none;
    //     }

    //     .search-form {
    //         width: 52rem;
    //     }
    // }


}

body.page-product .header .navi>ul li:nth-child(1) a,
body.page-product-category .header .navi>ul li:nth-child(1) a,
body.page-commission .header .navi>ul li:nth-child(2) a,
body.page-journal-page .header .navi>ul li:nth-child(4) a,
body.page-journal-tag .header .navi>ul li:nth-child(4) a {
    color: var(--theme-2);
}
</style>
